<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="merchantName" v-if="formType===2">
        <span slot="label">
          <a-tooltip>商家名称<template slot="title">商家名称</template></a-tooltip>
        </span>
        <a-input v-model="form.merchantName" disabled />
      </a-form-model-item>
      <a-form-model-item prop="withdrawAmount">
        <span slot="label">
          <a-tooltip>提现金额<template slot="title">提现金额</template></a-tooltip>
        </span>
        <a-input-number v-model="form.withdrawAmount" :disabled="formType===2"  style="width: 80%" :min="0" :max="merchantBalance" :step="0.01"  :placeholder="$t('请输入')+'提现金额'"/>
        <span v-if="formType===1">余额:{{merchantBalance}}</span>
      </a-form-model-item>
      <a-form-model-item prop="accountNo">
        <span slot="label"><a-tooltip>结算账号<template slot="title">结算账号</template></a-tooltip></span>
        <a-input v-model="form.accountNo" :disabled="formType===2" :maxLength="32" :placeholder="$t('请输入')+'结算账号'"/>
      </a-form-model-item>
      <a-form-model-item prop="accountName">
        <span slot="label"><a-tooltip>结算账户名
            <template slot="title">
              <p> 选择经营者个人银行卡时，开户名称必须与身份证姓名一致</p>
              <p> 选择对公账户时，开户名称必须与营业执照上的“商户名称”一致</p>
            </template>
          </a-tooltip>
        </span>
        <a-input v-model="form.accountName" :maxLength="32" :disabled="formType===2" :placeholder="$t('请输入')+'结算账户名'"/>
      </a-form-model-item>
      <a-form-model-item prop="accountBankName"  >
        <span slot="label" ><a-tooltip>开户银行名称<template slot="title">开户银行,输入并搜索</template></a-tooltip></span>
        <a-auto-complete class="global-search" v-if="formType===1" v-model="form.accountBankName"  style="width: 100%" placeholder="请输入开户银行查询" option-label-prop="title"
                         @select="handleBankChange"
                         @search="handleBankSearch">
          <template slot="dataSource">
            <a-select-option v-for="item in bankList" :key="item.bankName" :title="item.bankName">
              {{ item.bankName }}
            </a-select-option>
          </template>
        </a-auto-complete>
        <a-select v-model="form.accountBankName" :disabled="formType===2"  v-if="formType===2" :placeholder="$t('请输入')+'银行名称'">
          <a-select-option v-for="(item, index) in bankList" :value="item.bankName" :title="item.bankName" :key="item.bankName">
            {{ item.bankName }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item prop="accountBankAreaId" :disabled="formType===2">
        <span slot="label"><a-tooltip>开户银行地址<template slot="title">开户银行地址精确到市</template></a-tooltip></span>
        <a-cascader :options="cityList" :disabled="formType===2"
                    :field-names="{ label: 'areaName', value: 'areaId', children: 'children'}"
                    :placeholder="$t('请选择')+$t('商家账户.开户银行地址')"
                    style="width: 100%" v-model="citySelected" allowClear @change="onCityChange">
        </a-cascader>
      </a-form-model-item>
      <a-form-model-item prop="accountBankBranchCode" :disabled="formType===2">
        <span slot="label"><a-tooltip>开户支行<template slot="title">{{ $t('商家账户.开户支行') }}</template></a-tooltip></span>
        <a-button @click="openBranchSelect" :disabled="formType===2" style="text-align: left; width: 100%">
          {{ this.getBranchName() }}
        </a-button>
      </a-form-model-item>
      <a-form-model-item label="是否同意" prop="isPass" v-if="formType===2" >
        <a-radio-group v-model="form.isPass" button-style="solid">
          <a-radio-button v-for="(item, index) in this.customDict.TFEnum" :value="item.type" :key="index">
            {{ item.name }}
          </a-radio-button>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item v-if="!form.isPass && formType===2" label="拒绝原因"  prop="failReason" >
        <a-textarea v-model="form.auditReason" :maxLength="200" :placeholder="$t('请输入')+'拒绝原因'" />
      </a-form-model-item>
      <a-form-model-item  v-if="form.isPass" prop="voucherImg">
        <span slot="label">
          <a-tooltip>打款凭证<template slot="title">打款凭证</template></a-tooltip>
        </span>
        <oss-upload-single v-model="form.voucherImg" prefix="merchant" type="img"/>
      </a-form-model-item>
      <a-form-model-item prop="remark">
        <span slot="label">
          <a-tooltip>备注<template slot="title">备注</template></a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('请输入')" type="textarea" allow-clear/>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
    <radio-branch-select-form ref="RadioBranchSelectForm" @branchSelect="indexBranchSelect"></radio-branch-select-form>
  </a-drawer>
</template>

<script>
import {getMerchantWithdraw, addMerchantWithdraw, updateMerchantWithdraw} from '@/api/merchant/merchantWithdraw'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";
import OssUploadSingle from "@/components/OssUploadSingle/index.vue";
import {defaultBankAccount} from '@/api/merchant/bankAccount'
import {cityListTree} from "@/api/logistics";
import RadioBranchSelectForm from "@/views/merchant/branch/modules/RadioSelectForm.vue";
import {listBank} from "@/api/merchant/bank";
import {getMerchantAccount} from "@/api/merchant/merchantAccountBill";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    OssUploadSingle,
    RadioBranchSelectForm,
    CustomDictTag,
  },
  data() {
    return {
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      bankList : [],
      cityList:[],
      citySelected:[],
      submitLoading: false,
      formTitle: '',
      loading: '',
      merchantBalance: 0,
      // 表单参数
      form: {
        id: null,
        withdrawAmount: null,
        accountNo: null,
        accountName: null,
        accountBankName: null,
        accountBankAreaId: null,
        accountBankBranchCode : null,
        merchantId: null,
        isPass: false,
        auditReason: null,
        voucherImg: null,
        createTime: null,
        deptId: null,
        remark: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        withdrawAmount: [{required: true, message: '提现金额' + this.$t('不能为空'), trigger: 'blur'}],
        isPass: [{required: true, message: '审核状态' + this.$t('不能为空'), trigger: 'change'}],
        voucherImg: [{required: true, message: '打款凭证' + this.$t('不能为空'), trigger: 'blur'}]
      }
    }
  },
  filters: {},
  created() {
    this.getCityTree()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {},
  mounted() {
  },
  methods: {
    onClose() {
      this.cancel()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    getCityTree() {
      cityListTree().then(response => {
        this.cityList = response.data
      })
    },
    onCityChange() {
      this.form.accountBankAreaId=this.citySelected[1]
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        withdrawAmount: null,
        merchantId: null,
        accountNo: null,
        accountName: null,
        accountBankName: null,
        accountBankAreaId: null,
        accountBankBranchCode : null,
        isPass: false,
        auditReason: null,
        voucherImg: null,
        createTime: null,
        deptId: null,
        remark: null
      }
      this.bankList = []
      this.citySelected = []

    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('添加')
      this.getMerchantAmount();

      //查询当前商家的银行卡信息 银行卡回显出来
      defaultBankAccount().then(response => {
        if (response.data) {
          this.form.accountNo = response.data.accountNo
          this.form.accountName = response.data.accountName
          this.form.accountBankName = response.data.accountBankName
          this.form.accountBankAreaId = response.data.accountBankAreaId
          this.form.accountBankBranchCode = response.data.accountBankBranchCode
          this.form.accountBankBranchName = response.data.accountBankBranchName
          if (this.form.accountBankAreaId) {
            this.citySelected.push(this.form.accountBankAreaId.substring(0, 2) + '0000');
            this.citySelected.push(this.form.accountBankAreaId);
          }
          this.bankList.push({
            "bankName": response.data.accountBankName
          });
        }
      })
    },

    getMerchantAmount() {
      getMerchantAccount().then(response => {
        this.merchantBalance= Number(response.data.marginAmount)
      })
    },
    //银行选择
    handleBankSearch(value) {
      if (value === undefined) {
        return;
      }
      if (value === '') {
        return;
      }
      listBank({"bankAlias": value}).then(response => {
        this.bankList = response.data
      })
    },
    handleBankChange(value) {
      console.log('搜索选中了银行信息:',value)
      this.form.accountBankName = value;
    },
    openBranchSelect () {
      this.$refs.RadioBranchSelectForm.openBranch(this.form.accountBankName, this.form.accountBankBranchCode, this.form.accountBankAreaId);
    },
    indexBranchSelect(record) {

      this.form.accountBankBranchCode = record.code;
      this.form.accountBankBranchName = record.name;

      //自动选择地址
      this.form.accountBankAreaId=record.cityCode
      this.citySelected.push(record.cityCode.substring(0,2)+'0000')
      this.citySelected.push(record.cityCode)
    },
    getBranchName() {
      if (this.form.accountBankBranchCode) {
        return this.form.accountBankBranchName
      } else {
        return this.$t('请选择')+this.$t('商家账户.开户支行')
      }
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getMerchantWithdraw({"id": id}).then(response => {
        this.bankList.push({
          "bankName": response.data.accountBankName
        });
        this.form = response.data
        this.merchantBalance = this.form.withdrawAmount
        if (this.form.accountBankAreaId) {
          this.citySelected.push(this.form.accountBankAreaId.substring(0, 2) + '0000');
          this.citySelected.push(this.form.accountBankAreaId);
        }
        this.open = true
        this.formTitle = '审核'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('修改成功')
            updateMerchantWithdraw(this.form).then(response => {
              if (response.code==='20001') {
                this.$message.success(message, 3);
                this.open = false
                this.$emit('ok')
              }
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('修改成功')
            addMerchantWithdraw(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
